"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const forms_1 = require("../../forms");
const Button_styles_1 = require("./Button.styles");
const Button = (_a) => {
    var { label, buttonType: buttonTypeFromProps, onClick, disabled, icon: Icon, iconButtonPlacement, showSpinnerOnClick, buttonColor } = _a, rest = __rest(_a, ["label", "buttonType", "onClick", "disabled", "icon", "iconButtonPlacement", "showSpinnerOnClick", "buttonColor"]);
    const buttonType = buttonTypeFromProps !== null && buttonTypeFromProps !== void 0 ? buttonTypeFromProps : "contained";
    const ButtonContent = () => (react_1.default.createElement(react_1.default.Fragment, null, iconButtonPlacement === "after" ? (react_1.default.createElement(react_1.default.Fragment, null,
        label,
        Icon && react_1.default.createElement(Icon, null))) : (react_1.default.createElement(react_1.default.Fragment, null,
        Icon && react_1.default.createElement(Icon, null),
        label))));
    switch (buttonType) {
        case "outlined":
            return (react_1.default.createElement(Button_styles_1.Outlined, Object.assign({ type: "button", "$disabled": disabled, onClick: onClick, disabled: disabled, "$color": buttonColor }, rest),
                react_1.default.createElement(ButtonContent, null)));
        case "outlinedOnBackground":
            return (react_1.default.createElement(Button_styles_1.OutlinedOnBackground, Object.assign({ type: "button", "$disabled": disabled, onClick: onClick, disabled: disabled, "$color": buttonColor }, rest),
                react_1.default.createElement(ButtonContent, null)));
        case "text":
            return (react_1.default.createElement(Button_styles_1.Text, Object.assign({ type: "button", "$disabled": disabled, onClick: onClick, disabled: disabled, "$color": buttonColor }, rest),
                react_1.default.createElement(ButtonContent, null)));
        case "round":
            return (react_1.default.createElement(Button_styles_1.Round, Object.assign({ type: "button", "$disabled": disabled, onClick: onClick, disabled: disabled, "$color": buttonColor }, rest),
                react_1.default.createElement(ButtonContent, null)));
        case "small":
            return (react_1.default.createElement(Button_styles_1.Small, Object.assign({ type: "button", "$disabled": disabled, onClick: onClick, disabled: disabled, "$color": buttonColor }, rest),
                react_1.default.createElement(ButtonContent, null)));
        case "smallText":
            return (react_1.default.createElement(Button_styles_1.SmallText, Object.assign({ type: "button", "$disabled": disabled, onClick: onClick, disabled: disabled, "$color": buttonColor }, rest),
                react_1.default.createElement(ButtonContent, null)));
        case "contained":
        default:
            return (react_1.default.createElement(Button_styles_1.Contained, Object.assign({ type: "button", "$disabled": disabled, onClick: () => {
                    if (showSpinnerOnClick) {
                        return;
                    }
                    onClick();
                }, disabled: disabled, "$showSpinnerOnClick": showSpinnerOnClick, "$color": buttonColor }, rest), showSpinnerOnClick ? (react_1.default.createElement(Button_styles_1.LoaderWrapper, null,
                react_1.default.createElement(forms_1.Loader, null))) : (react_1.default.createElement(ButtonContent, null))));
    }
};
exports.Button = Button;
//# sourceMappingURL=Button.js.map